var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('v-app',[_c('router-view')],1):_c('SkeletonLayout',{attrs:{"captcha-valid":_vm.captchaValid}})}
var staticRenderFns = []

export { render, staticRenderFns }